module.exports = __webpack_public_path__ + "static/logo-resized-09fc12563be4bb37286341d498125996.png";